'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SocialSharingProps {
  title: string;
  description: string;
  url: string;
}

const SocialSharing = ({ title, description, url }: SocialSharingProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleFacebookShare = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };

  const handleTwitterShare = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      title
    )}&url=${encodeURIComponent(url)}`;
    window.open(twitterUrl, '_blank', 'width=600,height=400');
  };

  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${title} - ${url}`)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="py-16 px-4 bg-surface">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-card rounded-lg p-8 sm:p-12 shadow-sacred-md">
          <div className="flex justify-center mb-6">
            <div className="bg-secondary/10 rounded-full p-4">
              <Icon name="ShareIcon" size={40} className="text-secondary" />
            </div>
          </div>

          <h2 className="font-playfair text-3xl sm:text-4xl font-semibold text-foreground mb-4">
            Share Our Joy
          </h2>
          <p className="font-inter text-base text-muted-foreground mb-8 max-w-2xl mx-auto">
            Help us spread the word about our special day. Share our wedding website with family and friends.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-6">
            <button
              onClick={handleFacebookShare}
              className="flex items-center space-x-2 bg-[#1877F2] hover:bg-[#1877F2]/90 text-white px-6 py-3 rounded-lg font-inter font-medium transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <Icon name="ShareIcon" size={20} />
              <span>Facebook</span>
            </button>

            <button
              onClick={handleTwitterShare}
              className="flex items-center space-x-2 bg-[#1DA1F2] hover:bg-[#1DA1F2]/90 text-white px-6 py-3 rounded-lg font-inter font-medium transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <Icon name="ShareIcon" size={20} />
              <span>Twitter</span>
            </button>

            <button
              onClick={handleWhatsAppShare}
              className="flex items-center space-x-2 bg-[#25D366] hover:bg-[#25D366]/90 text-white px-6 py-3 rounded-lg font-inter font-medium transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <Icon name="ShareIcon" size={20} />
              <span>WhatsApp</span>
            </button>

            <button
              onClick={handleCopyLink}
              className="flex items-center space-x-2 bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 rounded-lg font-inter font-medium transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <Icon name={copied ? 'CheckIcon' : 'LinkIcon'} size={20} />
              <span>{copied ? 'Copied!' : 'Copy Link'}</span>
            </button>
          </div>

          <p className="font-inter text-xs text-muted">
            Your support means the world to us
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialSharing;